import axios from 'axios';

const camelToSnakeCase = (str) => {
  return str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
};
const toCamelCase = (str) => {
  return str.replace(/([-_][a-z])/g, (group) =>
    group.toUpperCase().replace('-', '').replace('_', ''),
  );
};

export const convertObjectKeysToCamelCase = (obj) => {
  const newObj = {};
  Object.keys(obj).forEach((key) => {
    newObj[toCamelCase(key)] = obj[key];
  });
  return newObj;
};

export const convertApiParams = (obj) => {
  const result = {};
  // eslint-disable-next-line no-unused-vars
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const newKey = camelToSnakeCase(key);
      result[newKey] = obj[key];
    }
  }
  return result;
};

export const createApiRequest = async (fn = () => {}) => {
  try {
    const response = await fn;

    if (response.status >= 400) {
      return { success: false, error: response.statusText };
    }
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const createPostRequest = async ({ url, params }) =>
  await createApiRequest(axios.post(`${FYM_BACKEND_URL}${url}`, params));

export const createPutRequest = async ({ url, params }) =>
  await createApiRequest(axios.put(`${FYM_BACKEND_URL}${url}`, params));

export const createDeleteRequest = async ({ url }) =>
  await createApiRequest(axios.delete(`${FYM_BACKEND_URL}${url}`));

export const createPatchRequest = async ({ url, params }) =>
  await createApiRequest(axios.patch(`${FYM_BACKEND_URL}${url}`, params));
